module.exports = __webpack_public_path__ + "static/img/1_3.86ee5187.jpg";